export default __webpack_public_path__ + "static/media/PTSans-Regular.334e1813.ttf";